<template>

  <Animate ref="animate" />

  <div class="teacher">
    <p class="title">{{$t('structure.教师')}}</p>
    <el-row >
      <el-col :offset="2" :span="20" class="col">
        <member-item :members="teaMembers"></member-item>
      </el-col>
    </el-row>
  </div>


  <div class="doctor">
    <p class="title">{{$t('structure.博士生')}}</p>
    <el-row >
      <el-col :offset="2" :span="20" class="col">
        <member-item :members="doctorMembers"></member-item>
      </el-col>
    </el-row>
  </div>


  <div class="master">
    <p class="title">{{$t('structure.硕士生')}}</p>
    <el-row >
      <el-col :offset="2" :span="20" class="col">
        <member-item :members="masterMembers"></member-item>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import { query, queryEntire } from '@/network/instruct'
  import MemberItem from "../childComps/MemberItem";
  import Animate from "@/components/common/Animate";

  import {ref, reactive, getCurrentInstance, onMounted} from 'vue'
  import { useRoute, useRouter } from 'vue-router';
  import {ElMessage} from 'element-plus'
  import { useI18n } from 'vue-i18n'//要在js中使用国际化

  export default {
    name: "structure",
    components:{
      MemberItem,
      Animate,
    },
    setup(){

      // t 引用i18n
      const { t } = useI18n()
      let instance = reactive({})
      instance = getCurrentInstance();

      const router = useRouter()
      let teaMembers = reactive([]);
      let doctorMembers = reactive([])
      let masterMembers = reactive([]);

      onMounted(() => {
        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })



      //装填教师学生数据
      queryEntire().then(res => {
        const { data } = res
        if (res.state === 200){
          data.forEach(item => {
            if (item.role === 1)
              teaMembers.push(item)
            if (item.role === 0)
              doctorMembers.push(item)
            if (item.role === -1)
              masterMembers.push(item)
          })

        } else if (res.state === '50000'){
          //router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录, 否则无法访问组织架构信息'));
        }
      })



      return{ teaMembers, doctorMembers, masterMembers,

      }
    },//setup
  }
</script>

<style scoped lang="less">

  .teacher, .doctor, .master{
    .title:before{
      content: ' ';
      height: 15px;
      width: 10px;
      background: #24a056;
      display: inline-flex;
      margin-right: 10px;
    }
    .title{
      font-size: 20px;
      text-align: center;
      padding: 20px 0 30px 0;
    }
    .col{
      text-align: center;
    }
  }



</style>